import React, { Component } from 'react';
import Api from '../../api/Api.js';
import CFPortalEndpoints from '../../api/PluginEndpoints/CFPortalEndpoints';

class AddShortCode extends React.Component {

    state = {
        shortCodeDetails: null
    }

    submit() {
        return null;
    }

    componentDidUpdate(prevProps) {
        if(prevProps.parentState.product_reference !== this.props.parentState.product_reference && this.props.parentState.product_reference.length === 5) {
            Api.get(CFPortalEndpoints.shortCodeDetails, { Short_Code: this.props.parentState.product_reference })
            .then(({ data }) => {
                this.setState({ shortCodeDetails: data })
            })
            .catch((e) => {
                console.error("Error Retrieving CFPortal Details", e);
                this.setState({ shortCodeDetails: null })
            })
        }
    }

    render() {
        if(this.state.shortCodeDetails)
            return (
                <div>
                    {
                        this.state.shortCodeDetails.Active === 'Y' ?
                            <span>Short Code <strong>Active</strong> on Cellfind Portal</span>
                            :
                            <span>Short Code <strong>Disabled</strong> on Cellfind Portal</span>
                    }
                </div>
            );
            else return null;
    }
}

export default AddShortCode;